// extracted by mini-css-extract-plugin
export default {"container":"AdditionalFeature_container__sEOPe","icon":"AdditionalFeature_icon__wCnj3","title":"AdditionalFeature_title__Vmu5E","text":"AdditionalFeature_text__PGRg7"};